import bugsnagClient from '@/plugins/bugsnag';
import router from '@/router';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import _ from 'lodash';

const apiAuthConstructor: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiAuthConstructor.interceptors.response.use(
  (response: any) => {
    localStorage.setItem('access_token', response.data.access_token);
    return response;
  },
  (error: any) => Promise.reject(error),
);

const apiConstructor: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiConstructor.interceptors.request.use((config: AxiosRequestConfig) => {
  _.merge(config.headers, {
    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
  });
  return Promise.resolve(config);
});

apiConstructor.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      router.push('/login');
    } else {
      bugsnagClient.notify(error);
      return Promise.reject(error);
    }
  },
);

export { apiAuthConstructor, apiConstructor };
